import React from 'react';
import Modal from '@material-ui/core/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {Tools} from './Tools';
import {Story} from './Inc';
import CancelIcon from '@material-ui/icons/Cancel';
import './Archive.scss';

interface Props {
    isOpen:boolean,
    yes():void,
    close():void,
    archive:Story,
}

const ArchiveDelete = (props:Props)=> {
    //Ajax.setUid(props.uid);
    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.isOpen}
            onClose={props.close}
        >
            <div style={Tools.getModalStyle()} className="panel">
                <div className="dialogRoot">
                    <div style={{marginBottom:"1em"}}>
                        {props.archive && props.archive.title}<br/>
                        削除して良い？
                    </div>
                    
                    <Tooltip title="削除しない"><Button variant="outlined" color="primary" style={{width:"60%"}} onClick={props.close}>しない</Button></Tooltip>
                    <Tooltip title="削除する"><Button variant="contained" color="secondary" style={{width:"40%"}} onClick={props.yes}>削除</Button></Tooltip>

                    <IconButton aria-label="close" onClick={props.close} color="primary" style={{position:"absolute",top:"-0.3em",right:"-0.3em"}}>
                        <CancelIcon/>
                    </IconButton>
                </div>
            </div>
        </Modal>
	);
}

export default ArchiveDelete;